import Dispatcher from '../../../flux/dispatcher/dispatcher';
import Constants from '../constant/ResetPasswordConstant';
var EventEmitter = require('events').EventEmitter;
var assign = require('object-assign');
var RESPONSE_CHANGE_EVENT = 'globalResponse';

var response = {}
function parseResponse(resp) {
    response = resp;
}

var ResetPasswordStore = assign({}, EventEmitter.prototype, {
    emitChangeEvent: function (event) {
        this.emit(event);
    },
    bind: function (callback) {
        this.on(RESPONSE_CHANGE_EVENT, callback);
    },
    unbind: function (callback) {
        this.removeListener(RESPONSE_CHANGE_EVENT, callback);
    },
    getResponse: function () {
        return response;
    }
});

Dispatcher.register(function (action) {
    switch (action.actionType) {
        case Constants.PASSWORD_RESET:
            var resp = action.data;
            parseResponse(resp)
            // console.log("resetpassword store......", resp)
            ResetPasswordStore.emitChangeEvent(RESPONSE_CHANGE_EVENT);
            break;

        default:
    }
});

export default ResetPasswordStore;